import { connect } from 'react-redux'
import Category from '../components/Category'
import { fetchItems, openItemDetail, fetchFeature } from '../actions'
import {
  LOAD_NEXT_PAGE_FEATURE_ITEMS,
  MODAL_ENABLE_SCROLL,
} from '../actions'
import { push } from 'react-router-redux'
import _ from 'lodash'

const mapStateToProps = (state, props) => {
  const { params: { categorySlug, featureId } } = props
  const { categories, feature, images } = state
  const loading = categorySlug ? state.category.loading : (state.feature.loading || state.category.loading)
  const error = categorySlug ? state.category.error : state.feature.error
  const category = categories.filter(c => c.slug === categorySlug)[0]
  const waitingNextPage = state.category.waitingNextPage
  const endOfList = state.category.endOfList
  return { items: state.category.items, category, images, loading,
           featureId, feature, error, waitingNextPage, categories, endOfList}
}

const mapDispatchToProps = (dispatch, props) => {
  const { params: { categorySlug, featureId } } = props
  console.log('featureId = ', featureId);
  const load = () => {
    if (categorySlug) {
      dispatch(fetchItems({category: categorySlug,
                           q: props.location.query['q'],
                           'price-from': props.location.query['price-from'],
                           'price-to': props.location.query['price-to'],
                          }))
    }
    if (featureId) {
      const category = props.location.query['category']
      console.log('category', category)
      dispatch(fetchFeature(featureId, _.get(props, 'routeParams.itemId'), category))
    }
  }
  return {
    hundleOnMout: () => {
      load();
    },
    handleDidUpdate: (prevProps, props) => {
      if (!_.isEqual(props.location.query, prevProps.location.query)) {
        load();
      }
    },
    openDetail: (item) => {
    },
    open: (to, query) => {
      dispatch(push({
        pathname: to,
        query
      }))
    },
    loadNextPage: () => {
      dispatch({
        type: LOAD_NEXT_PAGE_FEATURE_ITEMS,
      })
    },
    enableScroll: (enabled) => {
      dispatch({
        type: MODAL_ENABLE_SCROLL,
        enabled,
      })
    }
  }
}

const container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Category)

export default container



// WEBPACK FOOTER //
// ./src/containers/Category.js